import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        borderRadius: 8,
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 1.5,
            },
        },
        '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: 2,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    '& .MuiInputLabel-root': {
        fontWeight: 500,
        '&.Mui-focused': {
            color: theme.palette.primary.main,
        },
    },
    '& .MuiInputAdornment-root': {
        color: theme.palette.primary.main,
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
        opacity: 0,
        position: 'absolute',
        right: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer',
    },
}));

interface InlineDatePickerProps {
    label: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
    helperText?: string;
    disabled?: boolean;
    required?: boolean;
    fullWidth?: boolean;
    size?: 'small' | 'medium';
    min?: string;
    max?: string;
}

export const InlineDatePicker: React.FC<InlineDatePickerProps> = ({
    label,
    value,
    onChange,
    error = false,
    helperText,
    disabled = false,
    required = false,
    fullWidth = true,
    size = 'medium',
    min,
    max,
}) => {
    return (
        <StyledTextField
            label={label}
            type="date"
            value={value}
            onChange={onChange}
            error={error}
            helperText={helperText}
            disabled={disabled}
            required={required}
            fullWidth={fullWidth}
            size={size}
            inputProps={{
                min,
                max,
            }}
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <CalendarToday sx={{ fontSize: 20, pointerEvents: 'none' }} />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default InlineDatePicker;
